import { detectMobile, download, downloadFile }  from "./api.js";
import fetchSmart from "@/utils/fetch";
// 挂载全局方法
export default {
    install(Vue) {
        Vue.prototype.$isMobile = detectMobile();
        Vue.prototype.$fetch = fetchSmart;
        Vue.prototype.$download = download;
    }
}